import { useLocation } from "react-router-dom";

export const usePage = () => {
  const location = useLocation();
  let redirectTo = ''
  const redirectToUrl = new URLSearchParams(location.search).get("page");
  
  const redirect = redirectToUrl?.split('-')
  if(redirect) {
    redirectTo = redirect[1]
  }

  return { redirectTo };
};

export default usePage;
